import { GlobalResponseObject } from "../../global-response-object";
import { DivisionUserDetails } from "./division-details";


export class DivisionUnitResponse extends GlobalResponseObject{
data?:DivisionUserDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:DivisionUserDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}